import React from 'react';
import { Link, useLocation } from 'react-router-dom';

interface NavbarProps {
  onLogout: () => void;
}

const Navbar: React.FC<NavbarProps> = ({ onLogout }) => {
  const location = useLocation();

  const isActive = (path: string) => {
    return location.pathname === path ? 'nav-link active' : 'nav-link';
  };

  // O token JWT não carrega o nome do usuário (só id, empresa e flag de admin) — o nome
  // completo vem na resposta do login e é salvo em localStorage por App.tsx (handleLogin).
  const getUserFirstName = (): string => {
    const nomeCompleto = localStorage.getItem('userName');
    if (!nomeCompleto) return 'Usuário';
    return nomeCompleto.trim().split(' ')[0];
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-dark bg-primary fixed-top">
      <div className="container-fluid">
          <Link className="navbar-brand" to="/dashboard" style={{ display: 'flex', alignItems: 'center' }}>
              <i className="fas fa-graduation-cap" style={{ width: '20px', marginRight: '8px', marginLeft: '25px' }}></i>
              <span>Horus</span>
            </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav" style={{gap: '0.5rem', marginLeft: '8px'}}>

            <li className="nav-item">
              <Link
                className={isActive('/dashboard')}
                to="/dashboard"
                style={{ display: 'flex', alignItems: 'center' }}
              >
                <i className="fas fa-tachometer-alt" style={{ width: '20px', marginRight: '8px' }}></i>
                Dashboard
              </Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/periodos')} to="/periodos" style={{display: 'flex', alignItems: 'center'}}>
                <i className="fas fa-clock" style={{width: '20px', textAlign: 'center', marginRight: '8px'}}></i>
                Períodos e Horários
              </Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/professores')} to="/professores" style={{display: 'flex', alignItems: 'center'}}>
                <i className="fas fa-chalkboard-teacher" style={{width: '20px', textAlign: 'center', marginRight: '8px'}}></i>
                Professores
              </Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/disciplinas')} to="/disciplinas" style={{display: 'flex', alignItems: 'center'}}>
                <i className="fas fa-book" style={{width: '20px', textAlign: 'center', marginRight: '8px'}}></i>
                Turmas e Disciplinas
              </Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/laboratorios')} to="/laboratorios" style={{display: 'flex', alignItems: 'center'}}>
                <i className="fas fa-flask" style={{width: '20px', textAlign: 'center', marginRight: '8px'}}></i>
                Laboratórios
              </Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/grades')} to="/grades" style={{display: 'flex', alignItems: 'center'}}>
                <i className="fas fa-table" style={{width: '20px', textAlign: 'center', marginRight: '8px'}}></i>
                Grades
              </Link>
            </li>
            <li className="nav-item">
              <Link className={isActive('/relatorios')} to="/relatorios" style={{display: 'flex', alignItems: 'center'}}>
                <i className="fas fa-chart-line" style={{width: '20px', textAlign: 'center', marginRight: '8px'}}></i>
                Relatórios
              </Link>
            </li>
          </ul>
          <ul className="navbar-nav ms-auto">
            <li className="nav-item dropdown">
              <button 
                className="nav-link dropdown-toggle" 
                id="navbarDropdown" 
                data-bs-toggle="dropdown" 
                aria-expanded="false"
                style={{border: 'none', background: 'none', display: 'flex', alignItems: 'center'}}
              >
                <i className="fas fa-user" style={{width: '20px', textAlign: 'center', marginRight: '8px'}}></i>
                {getUserFirstName()}
              </button>
              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                <li>
                  <Link 
                    className="dropdown-item" 
                    to="/configuracoes"
                  >
                    <i className="fas fa-cog me-2"></i>
                    Configurações
                  </Link>
                </li>
                <li>
                  <button 
                    className="dropdown-item" 
                    onClick={onLogout}
                  >
                    <i className="fas fa-sign-out-alt me-2"></i>
                    Sair
                  </button>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;